var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"shrink mt-0 d-flex align-center",attrs:{"alt":"Geconomicus Name","max-height":"400px","src":require(("../assets/cards/card_" + _vm.random_number + ".jpeg"))}})}
var staticRenderFns = []

export { render, staticRenderFns }